// Build version information
declare global {
  const __BUILD_TIMESTAMP__: string;
  const __BUILD_VERSION__: string;
}

export const BUILD_VERSION = {
  timestamp: __BUILD_TIMESTAMP__,
  version: __BUILD_VERSION__,
  environment: import.meta.env.MODE,
};
